import { Button, Grid, Typography as MuiTypography } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const Container = styled(Grid)({
  height: "100%",
  position: "relative",
});

export const Hint = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "showHint",
})<{ showHint: boolean }>(
  ({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    right: 0,
    opacity: 0,
    visibility: "hidden",
    backgroundColor: alpha(theme.palette.secondary.dark, 0.1),
    transition: "all .4s ease",
  }),
  ({ showHint }) => ({
    ...(showHint && {
      opacity: 1,
      visibility: "visible",
    }),
  })
);

export const HintText = styled(Button)(({ theme }) => ({
  width: "100%",
  padding: 0,
  lineHeight: "40px",
  backgroundColor: theme.palette.background.default,
  textAlign: "center",
  color: theme.palette.text.primary,
  cursor: "pointer",
  textTransform: "none",
  transition: "all .4s ease",
  "&:hover": {
    color: theme.palette.primary.contrastText,
    backgroundColor: alpha(theme.palette.secondary.dark, 0.8),
  },
}));

export const Typography = styled(MuiTypography)(({ theme }) => ({
  padding: theme.spacing(2),
}));
